import axios from 'axios';
import { env } from '../../../config';
import { ModifyAddress } from '../geoMatchInterfaces';

export function getIPEAndBANAddresses(urlParams: string) {
  return axios.get(`${env.API_URL}/geomatch/loadIPEAndBANAddresses/?${urlParams}`);
}

export function modifyAddress(params: ModifyAddress) {
  return axios.post(`${env.API_URL}/geomatch/fixMismatch/`, params);
}
